"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rewards API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiveawayAggregatedStatisticsToJSON = exports.GiveawayAggregatedStatisticsFromJSONTyped = exports.GiveawayAggregatedStatisticsFromJSON = exports.instanceOfGiveawayAggregatedStatistics = void 0;
/**
 * Check if a given object implements the GiveawayAggregatedStatistics interface.
 */
function instanceOfGiveawayAggregatedStatistics(value) {
    var isInstance = true;
    isInstance = isInstance && "twitch" in value;
    isInstance = isInstance && "youtube" in value;
    isInstance = isInstance && "tiktok" in value;
    return isInstance;
}
exports.instanceOfGiveawayAggregatedStatistics = instanceOfGiveawayAggregatedStatistics;
function GiveawayAggregatedStatisticsFromJSON(json) {
    return GiveawayAggregatedStatisticsFromJSONTyped(json, false);
}
exports.GiveawayAggregatedStatisticsFromJSON = GiveawayAggregatedStatisticsFromJSON;
function GiveawayAggregatedStatisticsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'twitch': json['twitch'],
        'youtube': json['youtube'],
        'tiktok': json['tiktok'],
    };
}
exports.GiveawayAggregatedStatisticsFromJSONTyped = GiveawayAggregatedStatisticsFromJSONTyped;
function GiveawayAggregatedStatisticsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'twitch': value.twitch,
        'youtube': value.youtube,
        'tiktok': value.tiktok,
    };
}
exports.GiveawayAggregatedStatisticsToJSON = GiveawayAggregatedStatisticsToJSON;
